module.exports = __webpack_public_path__ + "static/img/hb_48-min.d2dcc98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_48-min.png
// module id = n1dK
// module chunks = 1